export default __webpack_public_path__ + "static/media/Leicht.7bbb847f.svg";